import { useQuery } from "react-query";

export function useUserPackNode() {
  return useQuery<{ packName: string[]; userName: string[] }>(
    "/api/rendering/user/consume/bill/getUserPackNodeParam"
  );
}
